export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "";

export const TPS_API_BASE_URL = process.env.REACT_APP_TPS_API_BASE_URL || "";
